import React from "react";
import Cards from "../Components/ServiceCards";
import services from "../Components/topthreeservices";
import Slide from "react-reveal/Slide";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import serv from "../pages/Service";
import { HashLink } from "react-router-hash-link";

const styles = {
  minHeight: "90vh",
  marginTop: "2em",
  paddingTop: "5em",
};

const TopServices = () => {
  return (
    <div style={styles} className="pt-md-3">
      <div>
        <h2
          className="text-center w-75 mt-5 "
          style={{
            display: "block",
            borderBottom: "1px solid red",
            width: "50%",
            margin: "0 auto",
            textTransform: "uppercase",
            fontWeight: "bold",
            color: "#FFC107",
          }}
        >
          Our Top Services
        </h2>
      </div>

      <div className="row d-flex card-section flex-md-row flex-sm-column  text-center mt-4 mx-auto mx-md-1 m mb-4 justify-content-center">
        {services.map((item) => (
          <Cards
            title={item.title}
            image={item.image}
            desc={item.description}
          />
        ))}
      </div>

      <a className="m-1 text-decoration-none" href="/services">
        <motion.button
          className="btn d-block btn-lg mx-auto text-white text-nowrap my-5"
          style={{ background: "#fd7e14" }}
          animate={{ scale: 1.08, boxShadow: "0 0 8px yellow" }}
          transition={{ yoyo: Infinity, delay: 2, duration: "1" }}
        >
          Our Services
        </motion.button>
      </a>
    </div>
  );
};

export default TopServices;
